import { AnnotationType, PieceAnnotation, PieceType } from '@apiContract';

import { MappedAnnotations } from './types';

export const AnnotationsMail = [AnnotationType.MailClass];

export const AnnotationsPackage = [
  AnnotationType.Reference1Number,
  AnnotationType.Reference2Number,
  AnnotationType.Reference3Number,
  AnnotationType.PurchaseInvoiceNumber,
  AnnotationType.PurchaseOrderNumber,
];

export const getAnnotationTextValueByType = (annotations: MappedAnnotations, type: AnnotationType) =>
  annotations?.[type];

export const getAnnotationsMapByType = (annotations: PieceAnnotation[], type: PieceType) => {
  const annotationsTypeSelect = type === PieceType.Mail ? AnnotationsMail : AnnotationsPackage;
  return annotations.reduce<{ [key: string]: string | null | undefined}>((acc, item) => {
    if (annotationsTypeSelect.includes(item.annotationType)) {
      acc[item.annotationType] = item.pieceAnnotationsMailClass?.shippingMailClass.name || item.textValue;
    }
    return acc;
  }, {});
}
